import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'


const UPDATE_LOG_CONTRACT_REQUEST = 'LogContract/UPDATE_LOG_CONTRACT_REQUEST'
const UPDATE_LOG_CONTRACT_SUCCESS = 'LogContract/UPDATE_LOG_CONTRACT_SUCCESS'
const UPDATE_LOG_CONTRACT_FAILURE = 'LogContract/UPDATE_LOG_CONTRACT_FAILURE'

const DELETE_LOG_CONTRACT_REQUEST = 'LogContract/DELETE_LOG_CONTRACT_REQUEST'
const DELETE_LOG_CONTRACT_SUCCESS = 'LogContract/DELETE_LOG_CONTRACT_SUCCESS'
const DELETE_LOG_CONTRACT_FAILURE = 'LogContract/DELETE_LOG_CONTRACT_FAILURE'

// Initialize State
const initialState = {
    isLoading: true,
    error: {}
}

// Default Reducer
const logContract = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_LOG_CONTRACT_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case UPDATE_LOG_CONTRACT_SUCCESS:
            return {
                ...state,
                isLoading: false
            }
        case UPDATE_LOG_CONTRACT_FAILURE:
            return {
                ...state,
                error: action.error,
                isLoading: false
            }
        case DELETE_LOG_CONTRACT_REQUEST:
            return {
            ...state,
            isLoading: true
            }
        case DELETE_LOG_CONTRACT_SUCCESS:
            return {
            ...state,
            isLoading: false
            }
        case DELETE_LOG_CONTRACT_FAILURE:
            return {
            ...state,
            error: action.error,
            isLoading: false
            }
        default:
            return state
        }
    }

export const updatLogContract = (data) => {
    return async (dispatch) => {
        try {
            dispatch({
                type: UPDATE_LOG_CONTRACT_REQUEST
            })

            await API.put(EndPoints.LOG_CONTRACT, data)
            dispatch({
                type: UPDATE_LOG_CONTRACT_SUCCESS
            })
            message.success(RESPONSE_MESSAGE.SUCCESS)
        } catch (err) {
            message.error(RESPONSE_MESSAGE.FAIL)
            dispatch({
                type: UPDATE_LOG_CONTRACT_FAILURE
            })
        }
    }
}

export const deleteLogContract = (id) => {
    return async (dispatch) => {
      try {
        dispatch({
          type: DELETE_LOG_CONTRACT_REQUEST
        })
  
        await API.delete(EndPoints.LOG_CONTRACT + `/${id}`)
        dispatch({
          type: DELETE_LOG_CONTRACT_SUCCESS
        })
        message.success(RESPONSE_MESSAGE.SUCCESS)
      } catch (err) {
        message.error(RESPONSE_MESSAGE.FAIL)
        dispatch({
          type: DELETE_LOG_CONTRACT_FAILURE
        })
      }
    }
  }